import {
  FETCH_ASSETLOT_PLAIN_BEGIN,
  FETCH_ASSETLOT_PLAIN_FAILURE,
  FETCH_ASSETLOT_PLAIN_SUCCESS,
  FETCH_TRANSACTION_STATUS_BEGIN,
  FETCH_TRANSACTION_STATUS_FAILURE,
  FETCH_TRANSACTION_STATUS_SUCCESS,
  FETCH_TRANSACTION_ASSETBYTYPE_BEGIN,
  FETCH_TRANSACTION_ASSETBYTYPE_SUCCESS,
  FETCH_TRANSACTION_ASSETBYTYPE_FAILURE,
} from "../constants/transaction";

const initialState = {
  statusList: [],
  assetLotsPlain: [],
  assetsByType: [],
};

export const transactionReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_TRANSACTION_STATUS_BEGIN:
      return {
        ...state,
        statusList: [],
      };
    case FETCH_TRANSACTION_STATUS_FAILURE:
      return {
        ...state,
        statusList: [],
      };
    case FETCH_TRANSACTION_STATUS_SUCCESS:
      return {
        ...state,
        statusList: payload.status,
      };
    case FETCH_ASSETLOT_PLAIN_BEGIN:
      return {
        ...state,
        assetLotsPlain: [],
      };
    case FETCH_ASSETLOT_PLAIN_FAILURE:
      return {
        ...state,
        assetLotsPlain: [],
      };
    case FETCH_ASSETLOT_PLAIN_SUCCESS:
      return {
        ...state,
        assetLotsPlain: payload.lots,
      };
      case FETCH_TRANSACTION_ASSETBYTYPE_BEGIN:
      return {
        ...state,
        assetsByType: [],
      };
    case FETCH_TRANSACTION_ASSETBYTYPE_FAILURE:
      return {
        ...state,
        assetsByType: [],
      };
    case FETCH_TRANSACTION_ASSETBYTYPE_SUCCESS:
      return {
        ...state,
        assetsByType: payload.assetsByType,
      };

    default:
      return state;
  }
};
